import type {DraftRepository} from './types'

// тут можно внедрить логгер и прочие зависимости
type DraftRepositoryParams = {
  key: string
}

export function createDraftRepository({key}: DraftRepositoryParams): DraftRepository {
  // если захочется другое хранилище, например переехать на бек или indexedDB
  // то в аргументах нужно завести условный fetch (слой инфтраструктуры)
  // и уже разруливать в нем
  return {
    fetchPersistDraftSync(str: string) {
      try {
        window.localStorage.setItem(key, str)
      } catch (e) {
        //
      }
    },
    fetchRestoreDraftSync(): string | undefined {
      try {
        return window.localStorage.getItem(key) || undefined
      } catch (e) {
        //
      }
    },
    fetchClearDraftSync() {
      try {
        window.localStorage.removeItem(key)
      } catch (e) {
        //
      }
    },
  }
}
